import { ShieldCheck, Shield, Building2, Clock } from "lucide-react";
import { useSiteSettings } from "../lib/useSiteSettings";
import { useT } from "../lib/i18n";
import { LEGAL } from "../lib/site";

export default function TrustBar() {
  const { certibiocide, rc_pro, siret: siretSetting } = useSiteSettings();
  const siret = siretSetting || LEGAL.siret.replace(/(\d{3})(\d{3})(\d{3})(\d{5})/, "$1 $2 $3 $4");
  const { lang } = useT();
  const en = lang === "en";
  const items = [
    certibiocide && { key: "certibiocide", icon: ShieldCheck, text: `Certibiocide n° ${certibiocide}` },
    rc_pro && { key: "rc-pro", icon: Shield, text: `${en ? "Professional liability insurance" : "Assurance RC Pro"} ${rc_pro}` },
    siret && { key: "siret", icon: Building2, text: `SIRET ${siret}` },
    { key: "devis", icon: Clock, text: en ? "Free quote within 24h" : "Devis gratuit sous 24h" },
  ].filter(Boolean);

  return (
    <section data-testid="trust-bar" aria-label={en ? "Trust" : "Confiance"} className="bg-[#1B5E20] text-white">
      <ul className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-4 flex flex-wrap justify-center gap-x-8 gap-y-3">
        {items.map(({ key, icon: Icon, text }) => (
          <li key={key} data-testid={`trust-item-${key}`} className="flex items-center gap-2 text-sm">
            <Icon className="w-4 h-4 text-[#A5D6A7] flex-shrink-0" />
            {text}
          </li>
        ))}
      </ul>
    </section>
  );
}
